import React from 'react';
import { Rocket } from 'lucide-react';
import { Button } from 'antd';

const GoLiveStage: React.FC<{ handleSubmit: () => void; isLoading: boolean }> = ({
	handleSubmit,
	isLoading,
}) => {
	return (
		<div className="px-2 text-center">
			{/* Ready to Launch Card */}
			<div className="max-w-2xl mx-auto rounded-2xl mb-8">
				<div className="flex justify-center mb-6">
					<div className="w-16 h-16 bg-white rounded-xl shadow flex items-center justify-center">
						<Rocket className="w-8 h-8 text-blue-500" />
					</div>
				</div>

				<h3 className="text-2xl font-semibold text-blue-700 mb-4">You're Ready to Go Live</h3>

				<p className="text-base leading-relaxed">
					Try a test call to see your receptionist in action!
				</p>
			</div>

			<div className="flex justify-center">
				<Button
					type="primary"
					size="large"
					onClick={handleSubmit}
					loading={isLoading}
					iconPosition="end"
					icon={<Rocket className="w-4 h-4" />}
					className="flex items-center gap-2"
				>
					Call my Receptionist
				</Button>
			</div>
		</div>
	);
};

export default GoLiveStage;
